import React, { useEffect, useState, useRef } from "react";
import { Spinner } from "reactstrap";
import { injectIntl } from "react-intl";

import { useFetch } from "../Base/Hooks/fetch";

import CredentialRow from "./CredentialRow";
import NewCredentials from "./NewCredentials";
import PageDisplay from "../Base/PageDisplay/PageDisplay";
import TableDisplay from "../Base/Shared/TableDisplay";
import SearchFilter from "../Base/Shared/SearchFilter";

import "./credentials.scss";

const Credentials = (props) => {
  const { title, updateState, history, match, intl, mainState } = props;
  const { formatMessage } = intl;
  const [pageTitle, setPageTitle] = useState("");
  const [searchText, setSearchText] = useState("");
  const [refreshFlag, setRefreshFlag] = useState(true);

  const [tableData, setTableData] = useState();
  const pageRef = useRef();

  const { error, loading, data } = useFetch(
    "/v1/" + match.params.sport + "/organizations/" + match.params.organizationId + "/credentials?limit=6000",
    "",
    refreshFlag,
    "location",
    true,
  );

  const columns = [
    formatMessage({
      id: "name",
      defaultMessage: "Name",
    }),
    formatMessage({
      id: "name.user",
      defaultMessage: "User Name",
    }),
    formatMessage({
      id: "user.type",
      defaultMessage: "User Typd",
    }),
    formatMessage({
      id: "date.expiry",
      defaultMessage: "Expiry Date",
    }),
    "",
  ];

  useEffect(() => {
    if (data) {
      setPageTitle(mainState.currentOrganizationName ? mainState.currentOrganizationName : "");

      let filteredData = data !== null ? data.data : [];

      if (searchText !== "") {
        filteredData = filteredData.filter((result) => {
          return (
            result.name.toUpperCase().indexOf(searchText.toUpperCase()) > -1 ||
            result.username.toUpperCase().indexOf(searchText.toUpperCase()) > -1
          );
        });
      }

      filteredData = filteredData.sort(function (a, b) {
        var aMixed = a["name"];
        var bMixed = b["name"];
        return aMixed < bMixed ? -1 : 1;
      });

      let tableList = filteredData.map((result, index) => (
        <CredentialRow
          key={index}
          itemIndex={index}
          result={result}
          updateState={updateState}
          match={match}
          pageRef={pageRef}
          setRefreshFlag={setRefreshFlag}
          intl={intl}
          reloadData={reloadData}
        />
      ));
      setTableData(tableList);
      setRefreshFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchText]);

  function reloadData() {
    setRefreshFlag(true);
  }

  return (
    <React.Fragment>
      {loading && <Spinner size="md" color="orange" />}
      {!loading && (
        <PageDisplay
          title={
            pageTitle +
            " " +
            formatMessage({
              id: "credentials",
              defaultMessage: "Credentials",
            })
          }
          error={error}
          pageTitle={
            pageTitle +
            formatMessage({
              id: "credentials",
              defaultMessage: "Credentials",
            }) +
            " - " +
            title
          }
          ref={pageRef}
          history={history}
        >
          <SearchFilter doSearch={setSearchText} />
          <NewCredentials reloadData={reloadData} match={match} pageRef={pageRef} />
          <TableDisplay containerClass="table-responsive" columns={columns} rows={tableData} loading={loading} />
        </PageDisplay>
      )}
    </React.Fragment>
  );
};

export default injectIntl(Credentials);
